import { Box, Button, Modal, Typography } from "@mui/material";

const DEFAULT_DATA = {
  SUCCESS: {
    title: "¡Listo!",
    subtitle: "",
    message: "Se ha guardado con éxito",
    btnTitle: "Aceptar"
  },
  ERROR: {
    title: "¡Error!",
    subtitle: "",
    message: "Parece que hubo un inconveniente al procesar tu solicitud. Por favor intenta nuevamente.",
    btnTitle: "Intentar de nuevo",
  },
}

export default function StatusModal(props) {
  const img = props.type == "SUCCESS" ? "/Sticker.png" : "/bad.png";
  return (
    <Modal
      disablePortal
      disableEnforceFocus
      disableAutoFocus
      open={props.show}
      aria-labelledby="server-modal-title"
      aria-describedby="server-modal-description"
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "70%",
          maxWidth: "sm",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 10,
        }}
      >
        <img width="70" src={img} alt="Estatus" />
        <Typography color="primary" mb={3} mt={3} variant="h4" component="h4" sx={{fontWeight: 500}}>
          {props?.title??DEFAULT_DATA[props.type].title}
        </Typography>
        <Typography color="primary" variant="h5" sx={{fontWeight: 500}}>
          {props?.subtitle??DEFAULT_DATA[props.type].subtitle}
        </Typography>
        <Typography variant="body1" mb={3}>
          {props?.message??DEFAULT_DATA[props.type].message}
        </Typography>
        <Button 
          onClick={props.closedModal}
          variant="contained"
          color="primary"
        >
          {props?.btnTitle??DEFAULT_DATA[props.type].btnTitle}
        </Button>
      </Box>
    </Modal>
  );
}
